import { createContext, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMachine } from '@xstate/react';

import { useDefaultCurrency, useSelectedSite } from '/src/hooks';
import { GOAL_ACTIONS, newGoalMachine, STATES } from '/src/features/goals/machines/wizard';

export const GoalWizardContext = createContext({});

import { GoalsWizard } from '/src/features/goals/components/wizard/GoalsWizard';

// eslint-disable-next-line
export default function NewGoalPage({ flow, onDone }) {
  const { selectedSite } = useSelectedSite();
  const location = useLocation();
  const navigate = useNavigate();
  const ctaId = useRef(location.state?.ctaId);

  const { defaultCurrency } = useDefaultCurrency();

  const [state, send, service] = useMachine(newGoalMachine, {
    devTools: true,
    context: {
      ctaId: ctaId.current,
      defaultCurrency,
      siteId: selectedSite?.id,
    },
  });

  useEffect(() => {
    if (selectedSite && !state.context.payload.siteId) {
      send({ type: GOAL_ACTIONS.SELECT_SITE, site: selectedSite });
    }
  }, [selectedSite, send, state.context.payload.siteId]);

  useEffect(() => {
    const subscription = service.subscribe((state) => {
      if (state.value === STATES.CANCELLED) {
        if (state.context.ctaId) {
          return navigate(`/addons/${state.context.ctaId}/edit`, { replace: true });
        }
        return navigate('/goals', { replace: true });
      }
      if (state.value === STATES.COMPLETED) {
        if (state.context.ctaId) {
          return navigate(`/addons/${state.context.ctaId}/edit`, {
            state: { goalId: state.context.goalId },
            replace: true,
          });
        }
        return navigate('/goals/new/success', { replace: true });
      }
    });

    return subscription.unsubscribe;
  }, [navigate, service]);

  return (
    <GoalWizardContext.Provider value={{ goalService: service }}>
      <GoalsWizard service={service} />
    </GoalWizardContext.Provider>
  );
}
